import { Injectable } from '@angular/core';
import { SignalRService, DIAGNOSTICS_COMPLETE } from 'app/shared/services/signalr.service';
import { SignalRMessageType } from 'app/shared/models/signalr-message';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DiagnosticService {
    public diagnosesRunning = new BehaviorSubject<Record<string, boolean>>({});

    constructor(private signalRService: SignalRService) {
        this.signalRService.messageReceived.subscribe(async (res) => {
            if (res && res.cid && res.type === SignalRMessageType.Info && res.message) {
                if (res.message.startsWith(DIAGNOSTICS_COMPLETE)) {
                    const current = this.diagnosesRunning.getValue();
                    current['id' + res.lid + res.cid] = false;
                    this.diagnosesRunning.next(current);
                }
            }
        });
    }
}
